





































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTopicSubject from '@/components/GTopicSubject.vue';
import { schoolSettingModule } from '@/store/modules/entities/school-setting.module';
import GLoading from '@/components/GLoading.vue';
import { required } from 'vuelidate/lib/validators';
import GOptionalIcon from '@/components/GOptionalIcon.vue';
import { SchoolSetting } from '@/models/school-setting';

@Component({
  name: 'GSchoolSetting',
  components: {
    GLoading,
    GTitleBar,
    GTopicSubject,
    GCustomBreadCrumb,
    GOptionalIcon,
  },
  computed: {},
  methods: {},
  validations: {},
})
export default class GSchoolSetting extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  lazy: boolean = false;
  processing: boolean = false;

  async mounted() {
    await schoolSettingModule.fetchSchoolSettingDetail();
    this.breadCrumbItems = [
      {
        title: this.$t('HOME').toString(),
        icon: 'ios-home',
        routerPath: '/pages/home',
      },
      { title: this.$t('SCHOOL_SETTING').toString() },
    ];
    this.lazy = true;
  }

  /**
   * 更新実行
   */
  handleCommit() {
    this.processing = true;
    schoolSettingModule.updateSchoolSetting().then(() => {
      this.showUpdateSuccessed();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    });
  }

  get schoolSetting(): SchoolSetting {
    return schoolSettingModule.schoolSetting;
  }

  get isProcessing(): boolean {
    return this.processing;
  }
}
